import React from 'react';
import styled from '@emotion/styled';
import { GridSpinner } from 'react-spinners-kit';

const Wrapper = styled.div`
  padding: 29px;
  text-align: center;
  padding-top: 150px;
  font-size: 40px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  status: 'PENDING' | 'ERROR' | 'COMPLETED';
  error: string | null;
  onRetry: () => void;
}

const InProgress: React.FC<Props> = ({ error, status, onRetry }) => {
  return (
    <Wrapper>
      <GridSpinner color="#fff" />
    </Wrapper>
  );
};

export default InProgress;
